import { useContext, useEffect } from "react";
import ViewAllTicketsComponent from "../components/tickets/ViewAllTickets";
import TitleContext from "../context/TitleContext";

export default function AllTicketsPage() {
  const { setTitle } = useContext(TitleContext);

  useEffect(() => {
    setTitle("Complaints");
  }, [setTitle]);
  return (
    <>
      <ViewAllTicketsComponent />
    </>
  );
}
